import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';
import { ImportModalComponent } from 'components/RootModal/modalRegistry';

export const CHAT_AGENT_DIALOG = 'CHAT_AGENT_DIALOG';

ImportModalComponent(CHAT_AGENT_DIALOG, () => import('./index'));

export const closeChatAgentDialog = () => {
  store?.dispatch(rootUiActions.removeDialog(CHAT_AGENT_DIALOG));
};

export type OpenChatAgentDialogProps = Record<string, never>;

const useChatAgentDialog = () => {
  return (_props: OpenChatAgentDialogProps = {}) => {
    store?.dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: CHAT_AGENT_DIALOG,
          type: CHAT_AGENT_DIALOG,
          props: ImmutableMap({
            onClose: closeChatAgentDialog,
          }),
        }),
      ),
    );
  };
};

export default useChatAgentDialog;
